import axios from 'axios';

export const deleteFile = async (fileId: string) => {
  await axios.post(`/asset/delete_file/${fileId}`);
};
